import { render } from "./HoveredActions.vue?vue&type=template&id=bfc0c62c"
import script from "./HoveredActions.vue?vue&type=script&lang=js"
export * from "./HoveredActions.vue?vue&type=script&lang=js"

import "./HoveredActions.vue?vue&type=style&index=0&id=bfc0c62c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__